module.exports = __webpack_public_path__ + "img/as1.c4568fe8.jpg";